import type {
  SignupCodeDetailsResponse,
  SignupCodeSession,
} from 'contracts/api/v4/signup-codes/signup-codes-details.service'

import type { NormalisedSignupCodeDetails } from './signup-codes-details.module.types'

export const handleSuccess = (
  response: SignupCodeDetailsResponse,
): NormalisedSignupCodeDetails => ({
  sessions: response.items.map((session: SignupCodeSession) => ({
    usedDate: new Date(session.created_on),
    user: {
      id: session.user_profile.id,
      email: session.user_profile.email,
      firstName: session.user_profile.first_name,
      lastName: session.user_profile.last_name,
      volunteerGroups: session.user_profile.volunteer.volunteer_groups.map(
        (volunteerGroup) => volunteerGroup,
      ),
    },
  })),
})
